<template lang='pug'>
  i.svg-icon.svg-icon-cheerAnimate
    svg(
      stroke=''
      :width='`${size}px`'
      :height='`${size}px`'
      viewBox='0 0 400 400'
      class='cheerAnimate')
      g
        rect(class="confetti-piece color1" x="195" y="195" width="10" height="10" style="--tx: -100px; --ty: -150px; --r: 720deg;")
        circle(class="confetti-piece color2" cx="200" cy="200" r="6" style="--tx: 120px; --ty: -130px; --r: 360deg;")
        rect(class="confetti-piece color3" x="195" y="195" width="8" height="12" style="--tx: 80px; --ty: -180px; --r: -300deg;")
        circle(class="confetti-piece color4" cx="200" cy="200" r="5" style="--tx: -90px; --ty: -160px; --r: 540deg;")
        rect(class="confetti-piece color5" x="195" y="195" width="12" height="8" style="--tx: 150px; --ty: -100px; --r: 270deg;")
        circle(class="confetti-piece color1" cx="200" cy="200" r="7" style="--tx: -140px; --ty: -90px; --r: -450deg;")
        rect(class="confetti-piece color2" x="195" y="195" width="9" height="9" style="--tx: 50px; --ty: -200px; --r: 600deg;")
        circle(class="confetti-piece color3" cx="200" cy="200" r="6" style="--tx: -50px; --ty: -170px; --r: 400deg;")
        rect(class="confetti-piece color4" x="195" y="195" width="11" height="7" style="--tx: 130px; --ty: -190px; --r: -180deg;")
        circle(class="confetti-piece color5" cx="200" cy="200" r="5" style="--tx: -110px; --ty: -110px; --r: 800deg;")
        rect(class="confetti-piece color1" x="195" y="195" width="10" height="10" style="--tx: 90px; --ty: -120px; --r: -600deg;")
        circle(class="confetti-piece color2" cx="200" cy="200" r="7" style="--tx: -150px; --ty: -180px; --r: 1000deg;")

      g(id="medal" transform="translate(0, 0)")
        circle(fill="#FFD700" cx="200" cy="200" r="90")
        circle(fill="#F7C700" cx="200" cy="200" r="74")
        path(fill="#fff" transform="translate(200, 200) scale(0.32) translate(-200, -200)" d=" M 200.00 57.03 L 234.47 140.83 A 12 12 0 0 1 247.54 145.33 L 332.50 159.78 A 12 12 0 0 1 338.12 175.37 L 283.11 224.08 A 12 12 0 0 1 277.49 239.67 L 290.55 324.12 A 12 12 0 0 1 276.06 334.33 L 203.12 291.81 A 12 12 0 0 1 196.88 291.81L 123.94 334.33 A 12 12 0 0 1 109.45 324.12 L 122.51 239.67 A 12 12 0 0 1 116.89 224.08 L 61.88 175.37 A 12 12 0 0 1 67.50 159.78 L 152.46 145.33 A 12 12 0 0 1 165.53 140.83 L 200.00 57.03 Z")

</template>

<script>
export default {
  props: {
    size: {
      type: Number,
      default: 20,
    },
    color: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang='scss'>
  .cheerAnimate {
    display: block;
    border-radius: 50%;
    margin: 10px auto;
    transform: scale(2);
  }

  /* 獎牌動畫 */
  #medal {
    transform-origin: center; /* 以中心為變形原點 */
    animation: medalAppear 0.5s ease forwards; /* 彈跳效果 */
    opacity: 0;
    animation-delay: 0.1s;
  }

  /* 紙屑/星星 基礎樣式 */
  .confetti-piece {
    transform-origin: center;
    opacity: 0;
    animation: burst 1.8s ease infinite;
  }

  /* 紙屑顏色 (可以增加更多) */
  .confetti-piece.color1 { fill: #E91E63; }
  .confetti-piece.color2 { fill: #2196F3; }
  .confetti-piece.color3 { fill: #4CAF50; }
  .confetti-piece.color4 { fill: #FFEB3B; }
  .confetti-piece.color5 { fill: #9C27B0; }

  /* 為不同的紙屑設定延遲 */
  #confetti rect:nth-of-type(1)  { animation-delay: 0.4s; }
  #confetti circle:nth-of-type(1) { animation-delay: 0.45s; }
  #confetti rect:nth-of-type(2)  { animation-delay: 0.5s; }
  #confetti circle:nth-of-type(2) { animation-delay: 0.55s; }
  #confetti rect:nth-of-type(3)  { animation-delay: 0.6s; }
  #confetti circle:nth-of-type(3) { animation-delay: 0.65s; }
  #confetti rect:nth-of-type(4)  { animation-delay: 0.7s; }
  #confetti circle:nth-of-type(4) { animation-delay: 0.75s; }
  #confetti rect:nth-of-type(5)  { animation-delay: 0.8s; }
  #confetti circle:nth-of-type(5) { animation-delay: 0.85s; }
  #confetti rect:nth-of-type(6)  { animation-delay: 0.9s; }
  #confetti circle:nth-of-type(6) { animation-delay: 0.95s; }

  /* 動畫定義 */
  @keyframes medalAppear {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    70% {
      transform: scale(1);
      opacity: 1;
    }
    100% {
      transform: scale(0.85);
      opacity: 1;
    }
  }

  /* 簡化的噴發動畫 (同前) */
  @keyframes burst {
    0% {
      transform: translate(0, 0) scale(0.5) rotate(0deg);
      opacity: 1;
    }
    100% {
      /* 每個紙屑的最終位置和旋轉應不同 - CSS 較難隨機化 */
      /* 這裡僅做一個大致向外的效果 */
      transform: translate(var(--tx, 0px), var(--ty, -150px)) scale(1.2) rotate(var(--r, 360deg));
      opacity: 0;
    }
  }
</style>
